package org.hs_soft.runmynesto.pages.home.sub_page.dashboard.mvi

import org.hs_soft.runmynesto.domain.model.home.dashboard.dashboard_config.ListShopItem
import org.hs_soft.runmynesto.domain.model.home.dashboard.get_shop_statics.ShopStatistic
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.calendar.MonthModel

sealed class DashboardEvent{

    data object DismissErrorDialog:DashboardEvent()

    data object OnBackGroundClick:DashboardEvent()

    data object OnDetailBackClick:DashboardEvent()

    data class OnDashboardItemClick(
        val item: ShopStatistic,
        val itemName:String,
    ):DashboardEvent()

    data class SetCompareSaleChartDialogStatus(
        val status: Boolean,
    ):DashboardEvent()

    data object GetShopStatics:DashboardEvent()
    
    data class GetOtherDaysCustomerClientsFrequency(val comparedDate: MonthModel)
        :DashboardEvent()

    data class GetOtherDaysCustomerSalesFrequency(val comparedDate: MonthModel)
        :DashboardEvent()

    data class GetCustomerFrequency(val selectedDate: MonthModel)
        :DashboardEvent()

    data class GetShopListItems(val selectedDate: MonthModel): DashboardEvent()

    data class SetCalendarStatus(val status:Boolean): DashboardEvent()


    data object GetDashboardConfigs:DashboardEvent()



    data class SetCompareClientChartDialogStatus(val status:Boolean)
        :DashboardEvent()

    data class FilterBasedOnRegion(val shopItem: ListShopItem?)
        :DashboardEvent()




}